import { defineComponent } from "@vue/composition-api";
import SummarizeTimelineItem from "./summarize-timeline-item.vue";
import { VBPopover } from "bootstrap-vue";
export default defineComponent({
  components: {
    SummarizeTimelineItem
  },
  directives: {
    "b-popover": VBPopover
  },
  props: {
    timeline: {
      type: Array,
      required: true
    }
  },
  methods: {
    closeAllPopovers() {
      this.timeline.forEach(item => {
        this.$root.$emit("bv::hide::popover", `summarize-email-timeline-item-${item.id}`);
      });
    }
  }
});